module.exports = __webpack_public_path__ + "img/camera.68c2ec96.png";